import React from 'react';

export const SuffixIcon = () => {
  return <img src={'./icons/arrow.svg'} alt='suffixIcon' style={{ transform: 'rotate(180deg)' }} />;
};
